import { FC, CSSProperties } from 'react';

import Jumbotron, { JumbotronProps } from 'modules/common/components/Jumbotron';

import styles from './Banner.module.scss';

interface Props {
  alt: string;
  bgImg: string;
  bgImgObjectFit?: 'cover' | 'contain';
  fullHeight?: boolean;
  fullHeightOption?: string; // example: 'height:800px'
  isJumbotronResponsive?: boolean;
  isAlignCenter?: boolean;
  jobTypeId?: string;
  jumbotronProps?: Pick<JumbotronProps, 'fullHeight' | 'isResponsive' | 'bgImgObjectFit'>;
  shouldUseOverlayBackgroundColor?: boolean;
  shouldUseOverlayPadding?: boolean;
}

const overlayStyleGenerator = (
  shouldUseOverlayBackgroundColor: boolean,
  shouldUseOverlayPadding: boolean,
  isAlignCenter: boolean
): CSSProperties => ({
  height: '100%',
  width: 'auto',
  backgroundColor: `${shouldUseOverlayBackgroundColor ? 'rgba(0, 0, 0, 0.5)' : 'transparent'}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: `${isAlignCenter ? 'center' : 'initial'}`,
  padding: `${shouldUseOverlayPadding ? '0 16px' : '0'}`,
  position: `absolute`,
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  overflow: 'hidden',
});

const Banner: FC<Props> = ({
  alt,
  bgImg,
  children,
  fullHeight = true,
  fullHeightOption = '',
  jobTypeId,
  isAlignCenter = true,
  shouldUseOverlayBackgroundColor = true,
  shouldUseOverlayPadding = true,
  jumbotronProps = {},
}) => (
  <Jumbotron
    bgImg={bgImg}
    alt={alt}
    bgPos="center"
    fullHeight={fullHeight}
    fullHeightOption={fullHeightOption}
    jobTypeId={jobTypeId}
    {...jumbotronProps}
  >
    <div
      style={overlayStyleGenerator(
        shouldUseOverlayBackgroundColor,
        shouldUseOverlayPadding,
        isAlignCenter
      )}
    >
      <div className={styles['content']}>{children}</div>
    </div>
  </Jumbotron>
);

export type { Props as BannerProps };
export default Banner;
